import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";

import { WaIcon } from "@ui/WaIcon";
import { Artist as Model } from "../../models";
import { FormattedMessage } from "react-intl";
import { messages } from "../../messages";

interface Props {
    artist: Model;
    style?: "headline";
    link?: boolean;
    children?: React.ReactNode;
}

export type ArtistProps = React.PropsWithChildren<Props>;

export const Artist = ({ artist, style, link, children }: ArtistProps) => {
    const isHeadlineStyle = style === "headline";
    const TitleTag: React.ElementType = isHeadlineStyle ? "h2" : "strong";
    const artistUrl = artist ? artist.getViewUrl() : null;
    const name = artist ? artist.getName() : "";
    const imageUrl = artist ? artist.getImageUrl() : null;
    let img = imageUrl != null
        ? <img key="image" alt={name} src={imageUrl} />
        : <></>;
    if (link && artistUrl) {
        img = <Link to={artistUrl}>{img}</Link>;
    }

    return (
        <div className={classNames("artist", "artist--list-item", { "artist--headline": isHeadlineStyle })}>
            <div className="artist__artwork">
                <div className="artist-image">
                    <div className="artist-image__content">{img}</div>
                </div>
            </div>
            <div className="artist__info">
                {isHeadlineStyle &&
                    <h5 key="format" className="artist__format">
                        <WaIcon name="artist" />
                        {" "}
                        <FormattedMessage {...messages.artistEntitySingular} />
                    </h5>
                }
                {link && artistUrl &&
                    <Link key="title" to={artistUrl} className="artist__link">
                        <TitleTag key="title" className={
                            classNames("artist__title", { "display-1": isHeadlineStyle })
                        }>{name}</TitleTag>
                    </Link>
                }
                {(!link || artistUrl == null) &&
                    <TitleTag key="title" className="artist__title">{name}</TitleTag>
                }
            </div>
            {children && <div className="artist__additions">{children}</div>}
        </div>
    );
};
